import { createApp } from 'vue'
// import {createHead} from '@vueuse/head'
import App from './App.vue'
import router from './router'
import store from './store'
import VueClipboard from 'vue-clipboard2'
import VueLazyLoad from 'vue3-lazyload'
import {createHead} from '@vueuse/head'
// import wxsdk from 'weixin-js-sdk'
import mitt from 'mitt'

import './assets/styles/global.css'
import './assets/styles/themes.css'
import './assets/styles/tailwind.css'
import './assets/styles/override.css'

// import VConsole from "vconsole";
// import { initPlugin } from 'vue-vconsole-devtools'
// initPlugin(new VConsole()); // 需要在创建Vue根实例前调用

// https://vue-meta.nuxtjs.org/guide/preparing.html#options
// import './assets/styles/themes/ltdgay.css'
// import './assets/styles/themes/gold.css'

// console.log(wxsdk);

const app = createApp(App)

app.config.globalProperties.$emitter = mitt()
app.use(createHead())
.use(store).use(router)
.use(VueClipboard).use(VueLazyLoad).mount('#app')


